import PropTypes from 'prop-types';
var propTypes = {
  className: PropTypes.string,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  height: PropTypes.string,
  helperText: PropTypes.node,
  helperTextState: PropTypes.oneOf(['default', 'error', 'success']),
  helperTextVisibility: PropTypes.oneOf(['auto', 'hidden', 'visible']),
  id: PropTypes.string,
  label: PropTypes.string,
  maxLength: PropTypes.number,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  resize: PropTypes.oneOf([true, false, 'both', 'horizontal', 'initial', 'vertical']),
  separateLabel: PropTypes.bool,
  value: PropTypes.string
};
export default propTypes;